/**
 * ---------------------------------------------------
 * PLAN
 * ---------------------------------------------------
 */
export const PLAN_REQUEST = '@plan/PLAN_REQUEST';
export const PLAN_REQUEST_SUCCESS = '@plan/PLAN_REQUEST_SUCCESS';
export const PLAN_REQUEST_FAILURE = '@plan/PLAN_REQUEST_FAILURE';

